import {Button} from "primereact/button";

import {computeErrorText, ErrorContactInfo, TitledErrorMessage} from "../component/I18nErrorMessage";
import LoadingIndicator from "../component/LoadingIndicator";
import {useRevaTranslation} from "../hooks/languageHooks";
import {useRevaDispatch, useRevaSelector} from "../redux/revaHooks";
import {selectError as selectSpecError, selectLoading as selectSpecLoading} from "../redux/specSlice";
import {querySpecsAsync} from "../redux/specThunk";
import {selectError as selectWmtsError, selectLoading as selectWmtsLoading} from "../redux/wmtsSlice";
import {queryCapabilitiesAsync} from "../redux/wmtsThunk";
import HeaderStub from "./HeaderStub";

function StaticDataLoadingIndicatorContent() {
    const {t, language} = useRevaTranslation();
    const dispatch = useRevaDispatch();

    const specLoading = useRevaSelector(selectSpecLoading);
    const specError = useRevaSelector(selectSpecError);

    const wmtsLoading = useRevaSelector(selectWmtsLoading);
    const wmtsError = useRevaSelector(selectWmtsError);

    const loading = specLoading || wmtsLoading;

    const onReloadSpec = () => {
        void dispatch(querySpecsAsync());
    };

    const onReloadWmts = () => {
        void dispatch(queryCapabilitiesAsync());
    };

    if (loading) {
        return <LoadingIndicator loading={loading} />;
    }

    return (
        <>
            {(specError || wmtsError) && (
                <div className="grow">
                    <div className="flex items-center justify-center h-full">
                        <div
                            className="bg-surface-0 dark:bg-surface-900 p-6 mt-8 shadow-2 rounded-border w-full"
                            style={{maxWidth: "60rem"}}
                        >
                            {specError && (
                                <TitledErrorMessage
                                    title={t("staticData.error.specLoadingFailed")}
                                    text={computeErrorText(t, language, {errorObject: specError})}
                                    className="p-8"
                                >
                                    <Button
                                        label={t("staticData.reload")}
                                        className="mt-4"
                                        onClick={onReloadSpec}
                                        severity="secondary"
                                    />
                                </TitledErrorMessage>
                            )}
                            {wmtsError && (
                                <TitledErrorMessage
                                    title={t("staticData.error.wmtsLoadingFailed")}
                                    text={computeErrorText(t, language, {errorObject: wmtsError})}
                                    className="p-8"
                                >
                                    <Button
                                        label={t("staticData.reload")}
                                        className="mt-4"
                                        onClick={onReloadWmts}
                                        severity="secondary"
                                    />
                                </TitledErrorMessage>
                            )}
                            <ErrorContactInfo className="w-full p-8" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

function StaticDataLoadingIndicator() {
    return (
        <>
            <HeaderStub />
            <div className="MainView grow shrink-0">
                <div className="flex flex-row w-full h-full">
                    <StaticDataLoadingIndicatorContent />
                </div>
            </div>
        </>
    );
}

export default StaticDataLoadingIndicator;
